export const headers = [
  {
    text: 'Type',
    value: 'type',
    class: 'events-table-header',
    isContactFiltered: true,
    isDashboardFiltered: true,
    sortable: false,
  },
  {
    text: 'Created By',
    value: 'user_name',
    class: 'events-table-header',
    isContactFiltered: true,
    isDashboardFiltered: false,
    sortable: false,
  },
  {
    text: 'Description',
    value: 'description',
    class: 'events-table-header',
    isContactFiltered: true,
    isDashboardFiltered: true,
    sortable: false,
  },
  {
    text: 'Created Date and Time',
    value: 'created_at',
    class: 'events-table-header',
    isContactFiltered: true,
    isDashboardFiltered: true,
    sortable: false,
  },
  {
    text: 'Contact',
    align: 'left',
    value: 'contact_name',
    class: 'events-table-header',
    isContactFiltered: false,
    isDashboardFiltered: true,
    sortable: false,
  },
];

export const eventTypes = [
  {
    id: 1,
    text: 'All Types',
    types: [],
    allWebTypes: true,
  },
  {
    id: 2,
    text: 'Comments',
    types: ['Contact Comments'],
  },
  {
    id: 3,
    text: 'Sent/Received Email',
    types: ['Email Sent', 'Email Received', 'Email Sent via 3rd Party'],
  },
  {
    id: 4,
    text: 'Opened Email',
    types: ['Email Opened'],
  },
  {
    id: 5,
    text: 'Clicked Email',
    types: ['Email Clicked'],
  },
  {
    id: 6,
    text: 'Inbound Calls',
    types: ['Inbound Call'],
  },
  {
    id: 7,
    text: 'Outbound Calls',
    types: ['Outbound Click to Call'],
  },
  {
    id: 8,
    text: 'Sent/Received Text',
    types: ['Text Sent', 'Text Received'],
  },
  {
    id: 9,
    text: 'Text Received',
    types: ['Text Received'],
  },
  {
    id: 10,
    text: 'Text Sent',
    types: ['Text Sent'],
  },
  {
    id: 11,
    text: 'Direct Mail',
    types: ['Sent Letter', 'Sent Postcard'],
  },
  {
    id: 12,
    text: 'Website Activity',
    types: ['Valuation Inquiry', 'Called', 'Created a Follow Up For', 'Search Performed', 'Property Viewed', 'Favorite Property Added', 'Favorite Property Removed', 'Bad Email Flagged', 'Visit', 'User Login', 'Saved Search Added', 'Saved Search Removed', 'Lead Assigned'],
  },
  {
    id: 19,
    text: 'Call Recording',
    types: ['Call Recording'],
  },
  {
    id: 20,
    text: 'Qualify Lead Created',
    types: ['Qualify Lead Created'],
  },
  {
    id: 21,
    text: 'Qualify Lead Updated',
    types: ['Qualify Lead Updated'],
  },
  {
    id: 22,
    text: 'Qualify Rep Note',
    types: ['Qualify Rep Note'],
  },
  {
    id: 23,
    text: 'Qualify User Note',
    types: ['Qualify User Note'],
  },
  {
    id: 24,
    text: 'Qualify Lead Unclaimed',
    types: ['Qualify Lead Unclaimed'],
  },
  {
    id: 25,
    text: 'Qualify Lead Claimed',
    types: ['Qualify Lead Claimed'],
  },
  {
    id: 26,
    text: 'Qualify Rep Text Sent',
    types: ['Qualify Rep Text Sent'],
  },
  {
    id: 27,
    text: 'Qualify Lead Deleted',
    types: ['Qualify Lead Deleted'],
  },
  {
    id: 28,
    text: 'Qualify Appointment Set',
    types: ['Qualify Appointment Set'],
  },
  {
    id: 29,
    text: 'Qualify Status Update',
    types: ['Qualify Status Update'],
  },
  {
    id: 30,
    text: 'Qualify Outbound SMS',
    types: ['Qualify Outbound SMS'],
  }
];

export const PROPERTY_FIELDS = {
  mls: 'MLS',
  address: 'Address',
  city: 'City',
  state: 'State',
  zip: 'Zip',
  beds: 'Beds',
  full_baths: 'Full baths',
  half_baths: 'Half baths',
  listing_price: 'Listing price',
  square_feet: 'Square feet',
  type: 'Type',
  url: 'Property Url',
};

export const MAX_FIELDS_PER_COLUMN = 4;
export const MAX_DESCRIPTION_LENGTH  = 60000;

export const dateFilters = [
  { 
    text: 'All Dates',
    value: null,
  },
  { 
    text: 'Yesterday', 
    value: 1,
  },
  { text: 'Last 7 days',
    value: 7,
  },
  { 
    text: 'Last month',
    value: 30,
  },
];
